import React, { useRef, useState, useEffect } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
// import InputMask from 'react-input-mask';
import styles from './footer.module.scss';
import FooterProps from '../../models/footer';
import { isEmail /*isPhoneNumber*/ } from '../../helpers/validators';
import Richtext from '../global/richtext/Richtext';
import LinkButton from '../global/linkButton/linkButton';
import RGB from '../../models/rgb';
import GoogleTagManagerService from '../../services/googleTagManager';
// import SMSService from '../../services/sms';

type Props = {
  data: FooterProps;
};

interface CProps {
  fontColor?: string;
  borderColor?: string | null;
}

const CustomStyles = styled.div`
  .${styles['footer__subscription-input']}::placeholder {
    color: ${(p: CProps) => p.fontColor};
  }
  .${styles['footer__subscription-wrapper']} {
    border-bottom-color: ${(p: CProps) => p.borderColor};
  }
`;

const Footer = ({ data }: Props) => {
  if (!data) return <></>;

  const emailRef = useRef<HTMLInputElement>(null);
  const [emailSignupMessage, setEmailSignupMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showEmailSignupMessage, setShowEmailSignupMessage] = useState(false);
  // const phoneNumberRef = useRef<HTMLInputElement>(null);
  // const [consentChecked, setConsentChecked] = useState(false);

  // const [textSignupMessage, setTextSignupMessage] = useState('');
  // const [showTextSignupMessage, setShowTextSignupMessage] = useState(false);
  // const [agreeToReceiveMessages, setAgreeToReceiveMessages] = useState('');
  // const [showAgreeToReceiveMessages, setShowAgreeToReceiveMessages] =
  //   useState(false);

  const messageTypes = {
    success: 'success',
    error: 'error',
    agree: 'agree'
  };

  // Display error and success message for email signup
  const displayEmailSignupMessage = (type: string) => {
    setEmailSignupMessage(
      type === messageTypes.success
        ? data.subscription.successMessage
        : data.subscription.errorMessage
    );
    setMessageType(type);
    setShowEmailSignupMessage(true);
    setTimeout(() => setShowEmailSignupMessage(false), 6000);
  };

  // Display error and success message for text signup
  // const displayTextSignupMessage = (type: string) => {
  //   setTextSignupMessage(
  //     type === messageTypes.success
  //       ? data.textSignup.successMessage
  //       : data.textSignup.errorMessage
  //   );
  //   setMessageType(type);
  //   setShowTextSignupMessage(true);
  //   setTimeout(() => setShowTextSignupMessage(false), 6000);
  // };

  // const displayConsentMessage = (type: string) => {
  //   setAgreeToReceiveMessages(
  //     type === messageTypes.agree ? data.textSignup.agreeToReceiveMessages : ''
  //   );
  //   setMessageType(type);
  //   setShowAgreeToReceiveMessages(true);
  //   setTimeout(() => setShowAgreeToReceiveMessages(false), 6000);
  // };

  const subscribe = () => {
    const email = emailRef?.current?.value || '';

    if (isEmail(email)) {
      fetch('/api/email/subscribeToGeneralUpdates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          externalId: email,
          email,
          utmCampaign: '',
          utmSource: '',
          zipCode: ''
        })
      })
        .then(() => {
          if (emailRef && emailRef.current) {
            emailRef.current.value = '';
          }
          displayEmailSignupMessage(messageTypes.success);
          GoogleTagManagerService.dataLayerEmailSubmitted();
          return null;
        })
        .catch(() => {
          displayEmailSignupMessage(messageTypes.error);
          GoogleTagManagerService.dataLayerErrorViewed(
            data.subscription.errorMessage,
            'Footer Email Subscription',
            'Email Address'
          );
        });
    } else {
      displayEmailSignupMessage(messageTypes.error);
      GoogleTagManagerService.dataLayerErrorViewed(
        data.subscription.errorMessage,
        'Footer Email Subscription',
        'Email Address'
      );
    }
  };

  // const textSignup = async () => {
  //   const phoneNumber = phoneNumberRef?.current?.value || '';

  //   if (!isPhoneNumber(phoneNumber)) {
  //     displayTextSignupMessage(messageTypes.error);
  //     return;
  //   }

  //   if (isPhoneNumber(phoneNumber) && !consentChecked) {
  //     displayConsentMessage(messageTypes.agree);
  //     return;
  //   }

  //   let response;

  //   try {
  //     response = await SMSService.subscribeUser(phoneNumber);

  //     if (!response) {
  //       displayEmailSignupMessage(messageTypes.error);
  //       displayConsentMessage(messageTypes.agree);
  //     } else if (phoneNumberRef && phoneNumberRef.current) {
  //       phoneNumberRef.current.value = '';
  //       setConsentChecked(false);
  //       displayTextSignupMessage(messageTypes.success);
  //     }
  //   } catch (err) {
  //     displayEmailSignupMessage(messageTypes.error);
  //     displayConsentMessage(messageTypes.agree);
  //   }
  // };

  useEffect(() => {
    const keydown = (e: any) => {
      if (e.keyCode === 13) {
        // Submit on enter
        subscribe();
      }
    };

    if (emailRef && emailRef.current) {
      emailRef.current.addEventListener('keydown', keydown);
    }

    return () => {
      if (emailRef && emailRef.current) {
        emailRef.current.removeEventListener('keydown', keydown);
      }
    };
  }, []);

  return (
    <div className={styles.footer}>
      <CustomStyles
        fontColor={data.fontColor}
        borderColor={new RGB(data.fontColor).toString(0.3)}
      >
        <div className={styles.footer__container}>
          <div className={styles.footer__row}>
            <div
              className={cx(
                styles.footer__block,
                styles['footer__block--subscription'],
                styles['footer__block--no-margin']
              )}
            >
              <div className={styles.footer__row}>
                <div className={cx(styles.footer__block)}>
                  <div className={styles.footer__subscription}>
                    <span
                      className={cx(
                        styles.footer__text,
                        styles['footer__subscription-title']
                      )}
                      style={{ color: data.fontColor }}
                    >
                      {data.subscription.title}
                    </span>
                    <div className={styles['footer__subscription-wrapper']}>
                      <input
                        ref={emailRef}
                        type="email"
                        name="email"
                        className={styles['footer__subscription-input']}
                        placeholder={data.subscription.placeholder}
                        style={{ color: data.fontColor }}
                      />
                      <button
                        onClick={() => subscribe()}
                        type="button"
                        className={styles['footer__subscription-button']}
                        style={{ color: data.fontColor }}
                        name="footer subscription"
                      >
                        {data.subscription.buttonLabel}
                      </button>
                    </div>
                    <span
                      className={cx(
                        styles['footer__subscription-message'],
                        styles[`footer__subscription-message--${messageType}`],
                        {
                          [styles['footer__subscription-message--visible']]:
                            showEmailSignupMessage
                        }
                      )}
                      style={{ color: data.fontColor }}
                    >
                      {emailSignupMessage}
                    </span>
                  </div>
                </div>
                {/* <div
                  className={cx(
                    styles.footer__block,
                    styles['footer__block--text-subscription']
                  )}
                >
                  <div className={styles.footer__subscription}>
                    <span
                      className={cx(
                        styles.footer__text,
                        styles['footer__subscription-title']
                      )}
                      style={{ color: data.fontColor }}
                    >
                      {data.textSignup.title}
                    </span>
                    <span
                      className={cx(
                        styles.footer__sub_text,
                        styles['footer__subscription-sub-title']
                      )}
                      style={{ color: data.fontColor }}
                    >
                      {data.textSignup.subTitle}
                    </span>

                    <div className={styles['footer__subscription-wrapper']}>
                      <InputMask
                        type="text"
                        name="phone"
                        className={styles['footer__subscription-input']}
                        placeholder={data.textSignup.placeHolder}
                        style={{ color: data.fontColor }}
                        mask="999-999-9999"
                      >
                        {(inputProps: any) => (
                          <input ref={phoneNumberRef} {...inputProps} />
                        )}
                      </InputMask>

                      <button
                        onClick={() => textSignup()}
                        type="button"
                        className={styles['footer__subscription-button']}
                        style={{ color: data.fontColor }}
                        name="footer signup"
                      >
                        {data.textSignup.buttonLabel}
                      </button>
                    </div>

                    <span
                      className={cx(
                        styles['footer__subscription-message'],
                        styles[`footer__subscription-message--${messageType}`],
                        {
                          [styles['footer__subscription-message--visible']]:
                            showTextSignupMessage
                        }
                      )}
                      style={{ color: data.fontColor }}
                    >
                      {textSignupMessage}
                    </span>

                    <div
                      className={cx(
                        styles.footer__block,
                        styles['footer__subscription-consent-wrapper']
                      )}
                    >
                      <span
                        className={cx(
                          styles.footer__text,
                          styles['footer__subscription-consent']
                        )}
                        style={{ color: data.fontColor }}
                      >
                        <input
                          checked={consentChecked}
                          onChange={() => {
                            setConsentChecked(!consentChecked);
                          }}
                          type="checkbox"
                          name="textconsent"
                          className={
                            styles['footer__subscription-consent-checkbox']
                          }
                        />
                      </span>
                      <span
                        className={cx(
                          styles.footer__text,
                          styles['footer__subscription-text-consent-agree-text']
                        )}
                      >
                        {data.textSignup.consent && (
                          <Richtext data={data.textSignup.consent} />
                        )}
                      </span>
                    </div>

                    <span
                      className={cx(
                        styles['footer__subscription-message'],
                        styles[`footer__subscription-message--${messageType}`],
                        {
                          [styles['footer__subscription-message--visible']]:
                            showAgreeToReceiveMessages
                        }
                      )}
                      style={{ color: data.fontColor }}
                    >
                      {agreeToReceiveMessages}
                    </span>
                  </div>
                </div> */}
              </div>
            </div>
            <div
              className={cx(
                styles.footer__block,
                styles['footer__block--links']
              )}
            >
              {data.links &&
                data.links.map((l: any) => (
                  <a
                    href={l.route}
                    key={`${l.label}-${l.route}-key-0`}
                    className={cx(styles.footer__text, styles.footer__link)}
                    style={{ color: l.customStyles?.color }}
                  >
                    {l.label}
                  </a>
                ))}
            </div>
            {data.social && (
              <div
                className={cx(
                  styles.footer__block,
                  styles['footer__block--social']
                )}
              >
                <span
                  className={styles.footer__text}
                  style={{ color: data.fontColor }}
                >
                  {data.social.title}
                </span>
                <div className={styles['footer__social-links']}>
                  {data.social.links &&
                    data.social.links.map((link) => (
                      <LinkButton key={link.label + link.route} data={link} />
                    ))}
                </div>
              </div>
            )}
          </div>
          <div className={styles.footer__row}>
            <div
              className={cx(
                styles.footer__block,
                styles['footer__block--bottom-links']
              )}
            >
              {data.bottomLinks &&
                data.bottomLinks.map((l: any) => (
                  <a
                    href={l.route}
                    key={`${l.label}-${l.route}-key-1`}
                    className={cx(
                      styles.footer__text,
                      styles['footer__link-bottom']
                    )}
                    style={{ color: l.customStyles?.color }}
                  >
                    {l.label}
                  </a>
                ))}
              <button
                type="button"
                className={cx(
                  'ot-sdk-show-settings',
                  styles['footer__link-bottom'],
                  styles['footer__one-trust-button'],
                  styles.footer__text
                )}
                title="Cookie Settings"
                name="cookie settings"
              >
                Cookie Settings
              </button>
            </div>
            <div
              className={cx(
                styles.footer__block,
                styles['footer__block--legal']
              )}
            >
              {data.legal && <Richtext data={data.legal} />}
            </div>
          </div>
        </div>
      </CustomStyles>
    </div>
  );
};

export default Footer;
